import { useUser } from '@clerk/clerk-react';

import { useEffect } from 'react';

import { useMutation } from 'convex/react';

import { api } from '../../convex/_generated/api';

export function EnsureUser() {
  const { user } = useUser();
  const ensureUser = useMutation(api.users.ensureUser);

  useEffect(() => {
    if (!user) return;
    const name = user.fullName!;
    const email = user.primaryEmailAddress!.emailAddress;
    if (!email) return;
    ensureUser({ name, email }).catch(() => {});
  }, [user, ensureUser]);

  return null;
}
